export const limitCharacters = (text, limit, endFill) => {
    if (text.length < limit) {
        return text;
    }
    let endOfWordAtTheLimit = text.indexOf(' ', limit);
    if (endOfWordAtTheLimit === -1) {
        endOfWordAtTheLimit = text.length;
    }
    if (endOfWordAtTheLimit === text.length) {
        return text;
    }
    if (!endFill) {
        return text.substring(0, endOfWordAtTheLimit);
    }
    return `${text.substring(0, endOfWordAtTheLimit)}${endFill || ''}`;
};
